/**
 * Zengin metin (HTML) içerik yardımcıları. Zengin metin editörüne geçişten sonra
 * içerik HTML olarak saklanır; geçiş öncesinde kaydedilmiş veriler düz metindir.
 */

/**
 * Editör çıktısı her zaman bir blok etiketiyle başlar. Desen dar tutulur: "içinde < var mı"
 * gibi gevşek bir kontrol, `a < b` yazan eski bir kaydı HTML sanıp temizlenmemiş içeriği
 * render etmeye yol açardı.
 */
const HTML_CONTENT_PATTERN = /^\s*<(p|ol|ul|h[1-6]|div|blockquote|pre)(\s[^>]*)?>/i;

/**
 * İçeriğin HTML mi düz metin mi olduğunu belirler.
 *
 * @param {unknown} content İçerik.
 * @returns {boolean} HTML olarak render edilmesi gerekiyorsa true.
 */
export const isHtmlContent = (content) => {
    if (typeof content !== 'string' || content.length === 0) return false;

    return HTML_CONTENT_PATTERN.test(content);
};

/**
 * Editör içeriğinin görünür metin taşıyıp taşımadığını kontrol eder. Boş bir editör
 * '<p><br></p>' üretir ve bu dize truthy olduğu için `.trim()` ile kontrol yanlış sonuç verir.
 *
 * @param {unknown} html İçerik.
 * @returns {boolean} Görünür metin yoksa true.
 */
export const isEmptyHtmlContent = (html) => {
    if (typeof html !== 'string' || html.length === 0) return true;

    const visibleText = html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\u00a0/g, ' ');

    return visibleText.trim().length === 0;
};
